import type { TFunction } from 'i18next';

export interface AdjustDiscrepancyApiError {
  code?: string;
  message: string;
  field?: string;
}

export const extractAdjustDiscrepancyError = (error: unknown): AdjustDiscrepancyApiError => {
  const err = error as { response?: { data?: Record<string, unknown> }; message?: string };
  const data = err?.response?.data;
  const apiError = data?.error as { error_code?: string; message?: string; field?: string } | undefined;
  const code: string | undefined = apiError?.error_code || (apiError as { code?: string })?.code;
  const message: string = apiError?.message || (data?.message as string) || err?.message || '';
  const field: string | undefined = apiError?.field;
  return { code, message, field };
};

const getLaravelValidationMessage = (error: unknown): string | undefined => {
  const err = error as { response?: { data?: { errors?: Record<string, string[]>; message?: string } } };
  const errors = err?.response?.data?.errors;
  if (errors) {
    const firstKey = Object.keys(errors)[0];
    if (firstKey && errors[firstKey]?.[0]) {
      return errors[firstKey][0];
    }
  }
  return err?.response?.data?.message;
};

export const mapAdjustDiscrepancyErrorMessage = (error: unknown, t: TFunction<'pickingModule'>): string => {
  const { code, message } = extractAdjustDiscrepancyError(error);
  const laravelMessage = getLaravelValidationMessage(error);

  switch (code) {
    case 'MISSING_ROLLBACK_PERMISSION':
      return t('adjust_discrepancy.errors.MISSING_ROLLBACK_PERMISSION');
    case 'PREPARATION_NOT_FOUND':
      return t('adjust_discrepancy.errors.PREPARATION_NOT_FOUND');
    case 'WRONG_TYPE_OF_PREPARATION':
      return t('adjust_discrepancy.errors.WRONG_TYPE_OF_PREPARATION');
    case 'PICKING_DISCREPANCY_INVALID_ORDERS':
      return t('adjust_discrepancy.errors.PICKING_DISCREPANCY_INVALID_ORDERS');
    case 'PICKING_DISCREPANCY_INSUFFICIENT_PICK_RECORDS':
      return t('adjust_discrepancy.errors.PICKING_DISCREPANCY_INSUFFICIENT_PICK_RECORDS');
    default:
      return laravelMessage || message || t('adjust_discrepancy.errors.generic');
  }
};
